/**
 *
 * https://komutteknolojisi.com
 *
 * @author Goncanur Uz <goncanur@komutteknolojisi.com>
 */

import { CancelToken, Method } from "axios";

/****************************************************/
/****************BASE URL *****************/
/****************************************************/
export const baseUrl = process.env.REACT_APP_BASE_URL;
export const imageUrl = process.env.REACT_APP_IMAGE_URL ?? "";

/****************************************************/
/**************** TYPES *****************/
/****************************************************/
export enum BodyType {
  raw,
  formdata,
}
export interface ApiParams {
  url: string;
  method?: Method;
  bodyType?: BodyType;
  body?: object;
  cancelToken?: CancelToken;
  token?: string;
  lng?: string;
}
export interface ApiUnderTheHoodParams {
  token?: string;
  lang?: string;
}
export interface SagaGenericParams<Type> {
  bodyType?: BodyType;
  payload: ApiCallback<Type>;
  body: object;
  url: string;
  id?: string;
  token?: string;
  lang?: string;
}
export interface SagaActionParams<Type> {
  payload: ApiCallback<Type>;
  url?: string;
  body?: object;
  id?: any;
  params?: any;
  token?: string;
  lang?: string;
}
export interface ApiResponse<ResultType = null> {
  Status: number;
  Message: string;
  Result: ResultType;
  Translates?: any;
  ResultDetail?: any;
  ErrorDetails?: any;
  ProcessTime: string;
}

/****************************************************/
/**************** API SAGA RESPONSE *****************/
/****************************************************/
export interface ApiSuccess<PayloadType = never> {
  onSuccess: (
    Message: string,
    Result: PayloadType,
    Response: ApiResponse<PayloadType>,
    Translates?: any
  ) => void;
}
export interface ApiFinally {
  onFinally?: () => void;
}

export interface ApiError {
  onError: (message: string) => void;
}

export interface ApiCallback<PayloadType = never>
  extends ApiSuccess<PayloadType>,
    ApiError,
    ApiFinally {}

export const verfiyResponse = (response?: ApiResponse<any>): boolean => {
  switch (response?.Status) {
    case 1: //Success = 1
      return true;
    case 2: //Error = 2
    case 3: //SystemErrorOccured = 3
    case 4: //SameRecordNotAdded = 4
    case 5: //CantDeleteHasSubRows = 5
    default:
      return false;
  }
};
